// extracted by mini-css-extract-plugin
export default {"self":"MassOfferingsLayout-module--self--w4SqO","footerWrapper":"MassOfferingsLayout-module--footerWrapper--0Vu9t"};